// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import SubscribeForm from './components/SubscribeForm';
import Footer from './components/Footer';
import About from './pages/About';
import Docs from './pages/Docs';
import Contact from './pages/Contact'; // Import the Contact component

const App = () => {
  const [lightPosition, setLightPosition] = useState({ x: -200, y: -200 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setLightPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <Router>
      <div className="relative bg-black text-white min-h-screen flex flex-col overflow-hidden">
        {/* Blurred light effect */}
        <div
          className="pointer-events-none absolute rounded-full bg-gray-500 opacity-30 blur-3xl transition-transform duration-300 ease-out"
          style={{
            width: '200px',
            height: '200px',
            transform: `translate(${lightPosition.x - 100}px, ${lightPosition.y - 100}px)`,
          }}
        />
        <Navbar />

        <main className="flex flex-col items-center justify-center flex-grow relative z-10">
          <Routes>
            <Route path="/" element={<SubscribeForm />} />
            <Route path="/about" element={<About />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/contact" element={<Contact />} /> {/* Add this line for the Contact page */}
            <Route path="/investor-info" element={<div>Investor Info Coming Soon</div>} /> {/* Placeholder for Investor Info */}
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
